import * as React from "react";
import { createRoot } from "react-dom/client";
import Home from "./home/Home";
import { LocaleContextProvider } from "../scripts/i18n";
import {
  BrowserRouter,
  Link,
  Navigate,
  Route,
  Routes,
  useParams,
} from "react-router";
import { MainView } from "./MainView";
import { useThemeInitialization } from "../scripts/theme";

type ContextWrapProps = {
  children: React.ReactNode;
};

const ContextWrap: React.FC<ContextWrapProps> = ({ children }) => {
  return <LocaleContextProvider>{children}</LocaleContextProvider>;
};

function AlbumRedirect() {
  const { aid } = useParams();
  return <Navigate to={`/view?album=${aid}`} replace />;
}

function AlbumTuneRedirect() {
  const { aid, tud } = useParams();
  return <Navigate to={`/view?album=${aid}&tune=${tud}`} replace />;
}

const AppContents: React.FC = () => {
  useThemeInitialization();
  return (
    <BrowserRouter basename="/app">
      <Routes>
        <Route path="/albums/:aid/tunes/:tud" element={<AlbumTuneRedirect />} />
        <Route path="/albums/:aid" element={<AlbumRedirect />} />
        <Route path="/view/*" element={<MainView />} />
        <Route path="/" element={<Home />} />
        <Route
          path="*"
          element={
            <div>
              Not Found.
              <Link to="/">Return to Home</Link>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

const App: React.FC = () => {
  return (
    <div>
      <ContextWrap>
        <AppContents />
      </ContextWrap>
    </div>
  );
};

const root = document.getElementById("app_root");
if (root) {
  createRoot(root).render(<App />);
}
